import { render, staticRenderFns } from "./ImportList.vue?vue&type=template&id=bec69bd2&scoped=true"
import script from "./ImportList.vue?vue&type=script&lang=js"
export * from "./ImportList.vue?vue&type=script&lang=js"
import style0 from "./ImportList.vue?vue&type=style&index=0&id=bec69bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec69bd2",
  null
  
)

export default component.exports